<template>
  <div
      v-tooltip.top="{
    content:openCaComponent.clientId && !event.new && auth.user.id === event.user.id ?'Replace With This Call?':''
      }"

    ref="event_block"
    class="v-cal-event-item"
    :class="eventClasses"
    @click.stop="eventClicked"
    :style="eventStyles"
  >
    <!--      :title="event.startTime"-->
    <div v-if="event.new" class="new-event-cancel-button-wrapper">
      <div class="event-cancel" @click.stop="cancelEvent" title="Cancel call">
        <i class="far fa-times-circle"></i>
      </div>


      <!--            <div class="event-save" @click.stop="saveEvent" title="Save cal"><i class="far fa-save"></i></div>-->

      <!--            <div class="event-save" @click.stop="saveEvent" title="Save cal"><i class="far fa-save"></i></div>-->
    </div>

    <button @click.stop="eventClicked" v-if="openCaComponent.clientId && !event.new && auth.user.id === event.user.id" class="fas fa-retweet"></button>

    <span class="v-cal-event-time" :class="{ 'new-item-time': event.new }"
      >{{ event.startTime | formatEventTime(use12) }} -
      {{ event.endTime | formatEventTime(use12) }}</span
    >
    <!--        <span class="v-cal-event-time v-cal-event-item-date">{{ moment(event.startTime).locale('LLLL')}}</span>-->
    <span class="v-cal-event-name" :class="{ 'new-item-content': event.new }">{{
      event.displayText
    }}
    </span>
    <!--        <div v-if="event.new" class="new-event-save-button-wrapper">-->
    <!--&lt;!&ndash;            <div class="event-cancel" @click.stop="cancelEvent" title="Cancel call"><i class="far fa-times-circle"></i></div>&ndash;&gt;-->
    <!--            <div class="event-save" @click.stop="saveEvent" title="Save cal"><i class="far fa-save"></i></div>-->
    <!--        </div>-->
  </div>
</template>

<script>
import moment from "moment";
import { EventBus } from "./EventBus";
import {mapGetters, mapState} from "vuex";
import IsView from "./mixins/IsView";
import ShowsTimes from "./mixins/ShowsTimes";

export default {
  name: "EventItem",
  props: {
    time: {
      type: Object
    },
    event: {
      type: Object,
      required: true
    },
    use12: {
      type: Boolean,
      required: true
    },
    hasDynamicSize: {
      type: Boolean,
      default: true
    },
    shift: {
      type: Array,
      default: () => []
    },
  },
  mixins: [IsView, ShowsTimes],
  data() {
    return {
      ancestorHeight: 0,
      now: moment(new Date()),
      nextCallOffset: 0
    };
  },
  mounted() {
    if (this.hasDynamicSize) {
      // this.getAndSetAncestorHeight();
      // window.addEventListener('resize', this.getAndSetAncestorHeight);
    }
    this.getNexCallOffset()

  },
  beforeDestroy() {
    // if ( this.hasDynamicSize )
    // window.removeEventListener('resize', this.getAndSetAncestorHeight);
  },
  methods: {
    getNexCallOffset(){
      //if($(".next-coming-call").offset().top == 0){
        // this.getNexCallOffset()
     // }
      if ($(".next-coming-call").offset() !== undefined) {
        this.nextCallOffset = $(".next-coming-call").offset().top;
      }
    },

    isComingCallClass(event) {
      // Function gets object of scheduled call, returns boolean. Sets css class only to future calls
      let time = moment(event.date);
      time.set("hour", event.startTime.hours());
      time.set("minute", event.startTime.minutes());
      if (moment(time) > moment()) {
        return true;
      } else {
        return false;
      }
    },
    cancelEvent() {
      EventBus.$emit("event-canceled", this.event);
    },
    saveEvent() {
      EventBus.$emit("save-call", this.event);
    },
    eventClicked() {
      if(this.openCaComponent.clientId){
        this.$emit('replaceClientCall')
      }else{
        EventBus.$emit("event-clicked", this.event);
      }
    },
    getAndSetAncestorHeight() {
      this.ancestorHeight = this.findAncestor(
        this.$refs.event_block,
        "v-cal-day__hour-content"
      ).offsetHeight;
    },
    findAncestor(el, cls) {
      while ((el = el.parentElement) && !el.classList.contains(cls));
      return el;
    },
    // getRandomColor(){ // Returns random color
    //     const randomColor = Math.floor(Math.random()*16777215).totoString(16);
    //     return "#" + randomColor;
    //     },
    // getRandomColor() { // Returns light color
    //     let color = "hsl(" + Math.random() * 360 + ", 100%, 75%)";
    //     return color;
    // },
    getRandomColor() {
      //Returns dark color
      let color = "#";
      for (let i = 0; i < 6; i++) {
        color += Math.floor(Math.random() * 10);
      }
      return color;
    },
    getColorOfUser() {
      if (this.event.user) {
        return JSON.parse(this.event.user.extra)
          ? JSON.parse(this.event.user.extra).options.color
          // : "gray";
          : this.getRandomColor();
      }
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["openCaComponent"]),

    displayHeight() {
      const end =
        this.event.endTime.hours() > 0
          ? moment(this.event.endTime)
          : moment(this.event.endTime).add(1, "days");

      const hours = end.diff(this.event.startTime, "hours", true);
      const bordersOffset = hours - 1;
      return hours * this.ancestorHeight + bordersOffset;
    },
    eventStyles() {
      let styles = [];
      styles.push({
        // 'backgroundColor': this.event.color,
        backgroundColor: this.getColorOfUser(),
        // 'backgroundColor': this.getRandomColor(),
        // 'color': this.event.color,
        // 'color':this.getColorOfUser(),
        color: this.getRandomColor(),
        "margin-right": "10px",
        flex: 1
        // 'max-width': '80px',
      });

      if (this.hasDynamicSize) {
        styles.push({
          // 'height': this.displayHeight + 'px',
          height: "23px"
        });

        if (this.event.overlaps > 0) {
          const width = 100 / (this.event.overlaps + 1);
          styles.push({
            // 'width': (width-10) + '%',
            // 'flex': 1,
            // 'left': width + '%',
          });
        }

        if (this.event.startTime.minutes() > 0) {
          const distance =
            (this.ancestorHeight / 60) * this.event.startTime.minutes();
          styles.push({
            top: distance + "px"
          });
        }
      }
      if (this.event.new) {
        styles.push({
          height: "max-content !important",
          backgroundColor: "green",
          display: "flex",
          "align-items": "center",
          left: "0%",
          width: "50%",
          "z-index": "2",
          "margin-right": "115px",
          "max-width": "200px",
          "flex-wrap": "wrap"
        });
      }
      if (this.openCaComponent.clientId === null) {
        styles.push({
          // 'backgroundColor': '#fa8100',
        });
      }
      return styles;
    },
    eventClasses() {
      return {
        "is-overlapping": this.event.overlaps > 0,
        new: this.event.new,
        "next-coming-call": this.isComingCallClass(this.event)
        // 'next-coming-call': this.event.startTime.hours().isBefore(this.now, 'hour')
      };
    }
  },
  filters: {
    formatEventTime(hour, use12 = false) {
      if (!hour) return "";

      if (use12)
        return hour.format(hour.minutes() > 0 ? "h.mma" : "ha").slice(0, -1);

      return hour.format(hour.minutes() > 0 ? "HH.mm" : "HH");
    }
  },
  watch: {
    nextCallOffset: function(nextCallOffset) {
      this.$emit("setNextCallOffset", nextCallOffset);
    }
  }
};
</script>

<style scoped>
.new-event-buttons-wrapper {
  margin-left: auto;
  display: flex;
  justify-content: space-between;
}
.event-cancel i,
.event-save i {
  /*margin-left: 20px;*/
  color: white;
  font-size: 14px;
  margin-right: 5px;
}
.event-cancel i:hover,
.event-save i:hover {
  transform: scale(1.2);
}
.event-save i:hover {
  color: #6aaaff;
}
.event-cancel i:hover {
  color: red;
}

/*.new:hover{*/
/*    height: 25px !important;*/
/*}*/
.v-cal-event-item-date {
  margin-left: 10px;
}
.new-event-cancel-button-wrapper,
new-event-save-button-wrapper,
.new-item-time {
  flex: 1;
}
.new-item-content {
  flex: 4;
}
.fa-retweet{
  font-size: 12px!important;
  font-weight: bold;
  /*width: 35px!important;*/
  color: #990000;
  margin-right: 3px;
}
</style>
